<ng-container *ngIf="(show$ | async) as show">
  <mb-link [dataColor]="dataColor || getCategoryColor(subCategory)"
           [dataCy]="'navigation-flyout-column-3-subcategory-' + subcategoryIndex + '-link-' + (index + 1)"
           [dataEventAction]="dataEventAction || ('Click ' + route?.label)"
           [dataEventLabel]="category?.label + '_' + subCategory?.label"
           [dataFilter]="dataFilter"
           [linkData]="{uid: route.isExternalUrl ? 'url' : cmsLinkType.CONTENT_LINK, url: route.url}"
           [useSlot]="true"
           (click)="onClose($event)"
           dataEventCategory="TopNavi"
           styleClass="is-link"
  >
    <span>{{ text || route?.label }}</span>
  </mb-link>
</ng-container>